<template>
    <div class="menu_left__container" ref="container">
        <MenuMobile v-if="isNotebook" :isUserAuth="isUserAuth" :favoriteItems="favoriteItems" :isLeftMenu="isLeftMenu" />
        <MenuItems v-else :collapse="isCollapse" :isUserAuth="isUserAuth" :favoriteItems="favoriteItems" :isLeftMenu="isLeftMenu" />
        <MenuSettings />
    </div>
</template>

<script>
import MenuItems from "./component/Items.vue";
import MenuMobile from "./component/Mobile.vue";
import {Listeners} from "../../constants/listeners";
import BrowserStorage from "../../mixins/BrowserStorage";
import WindowResize from "../../mixins/WindowResize";
import {StorageKeys} from "../../constants/storageKeys";
import {nextTick} from "vue";
import MenuSettings from "./component/Settings.vue";

export default {
    name: "MenuLeft",
    mixins: [BrowserStorage, WindowResize],
    props: {
        isUserAuth: {
            type: Boolean,
            required: true,
        },
        favoriteItems: {
            type: Array,
            required: true,
        },
        isLeftMenu: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            model: {
                collapse: false,
            },
            /**
             * Стилями проставляем 100vh - 60px, но в style проставляем уже рассчитанную скриптом
             */
            minHeightStyle: null,
            containerWidth: 0,
        };
    },
    created() {
        // необходимо для отслеживания CSS переменной --keysso-left-menu-width
        document.addEventListener("DOMContentLoaded", this.setContainerWidth);
    },
    mounted() {
        this.model.collapse = this.getLocalStorageItem(StorageKeys.LEFT_MENU_COLLAPSE) ?? false;
        this.$emitter.on(Listeners.LEFT_MENU_CLICK, this.onClickMenu);
    },
    computed: {
        isCollapse() {
            return this.model.collapse;
        },
    },
    methods: {
        onClickMenu() {
            if (this.isTablet) {
                this.$emitter.emit(Listeners.LEFT_MENU_MOBILE_TOGGLE);
                return;
            }

            this.model.collapse = !this.model.collapse;
            this.setLocalStorageItem(StorageKeys.LEFT_MENU_COLLAPSE, this.model.collapse);
            this.setContainerWidth();
        },
        setContainerWidth() {
            nextTick(() => {
                this.containerWidth = this.$refs.container?.offsetWidth ?? 0;
            });
        }
    },
    watch: {
        containerWidth() {
            // обновляем значение css переменной --keysso-left-menu-width
            document.documentElement.style.setProperty(
                '--keysso-left-menu-width',
                sprintf('%dpx', this.containerWidth)
            );
        },
    },
    components: {
        MenuSettings,
        MenuMobile,
        MenuItems,
    },
}
</script>

<style scoped>
.menu_left__container {
    height: 100%;
}
</style>
